export const getNumberDays = (date, months) => {
    const end = new Date(date);
    end.setMonth(end.getMonth() + months);
    const timeDifference = end - new Date(date); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to days
    return daysDifference;
};

export const convertDateType = (originDate) => {
    const date = new Date(new Date(originDate).toISOString().split("T")[0]);
    return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
    });
}

export const convertDateTime = (originDate) => {
    const date = new Date(new Date(originDate).toISOString().split("T")[0]);
    return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit",
        hour12: false, // Set to true for AM/PM format
    });
}

export const getBeforeDate = (date, months) => {
    const end = new Date(date);
    end.setMonth(end.getMonth() - months);
    return end;
}